import styled from 'styled-components';
import ClickOutside from 'library/components/click-outside';
import Colors from 'library/constants/colors';
import { ShadowElevation, TransitionConfig } from '../../constants/styles-config';
import { InputText } from '../../styles/text';

export const StyledClickOutside = styled(ClickOutside)`
  display: inline-block;
`;

export const OptionContainerStyles = `
  position: absolute;
  width: 280px;
  display: flex;
  flex-direction: column;  
  background-color: ${Colors.shade08};
  box-shadow: ${ShadowElevation};
  border-radius: 2px;
`;

export const OptionContainer = styled.div`
  ${OptionContainerStyles};
  padding-left: 15px;
  padding-top: 4px;
  padding-bottom: 4px;
`;

export const InputRadioStyles = `
  display: none;

  &:checked {
    + label {
      &:before {
        border-color: ${Colors.violet};
      }
      &:after {
        opacity: 1;
      }
    }
  }

  + label {
    ${InputText};
    position: relative;
    display: block;
    cursor: pointer;
    height: 40px;
    line-height: 18px;
    padding-top: 11px;
    padding-left: 29px;
    box-sizing: border-box;
    transition: color ${TransitionConfig};

    &:hover {
      &:before {
        border-color: ${Colors.violet};
      }
    }

    &:before {
      content: '';
      position: absolute;
      border: 2px solid ${Colors.shade03};
      box-sizing: border-box;
      transition: border-color ${TransitionConfig};
    }

    &:after {
      content: '';
      position: absolute;
      box-sizing: border-box;
      opacity: 0;
      background-color: ${Colors.violet};
      transition: background-color ${TransitionConfig};
    }
  }
`;

export const InputRadio = styled.input`
  ${InputRadioStyles};

  + label {
    &:before {
      top: 9px;
      left: 0;
      width: 20px;
      height: 20px;
      border-radius: 10px;
    }

    &:after {
      top: 14px;
      left: 5px;
      width: 10px;
      height: 10px;
      border-radius: 10px;
    }
  }
`;
